export default {
  data() {
    return {
      searchFraze: '',
      searchFocus: false,
      searchBlur: false
    }
  },

  methods: {
    resetSearchFraze() {
      this.searchFraze = ''
    },

    setSearchFocus() {
      this.searchFocus = true
      this.$nextTick(() => {
        this.searchFocus = false
      })
    },

    setSearchBlur() {
      this.searchBlur = true
      this.$nextTick(() => {
        this.searchBlur = false
      })
    }
  }
}